import axios from "axios";
import { toast } from "react-toastify";

export const signupUser = (values) => {
	return async (dispatch) => {
		try {
			const { data } = await axios({
				method: "post",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `user/signup`,
				data: {
					company_name: values.company_name,
					address: values.address,
					company_phone: values.company_phone,
					company_email: values.company_email,
					user_email: values.user_email,
					user_phone: values.user_phone,
					password: values.password,
				},
			});
			
			toast.success("Registration successful! Please login to continue.");
			return "success";
		} catch (error) {
			console.log(error.message);
			const errorMessage = error.response?.data?.message || "Registration failed. Please try again.";
			toast.error(errorMessage);
			return "error";
		}
	};
};
